export default __webpack_public_path__ + "static/media/placeholder-barbershop.d3b29c25.jpg";